import angular from 'angular';
import ContactListComponent from './contact-list-component';

export default angular.module('contact-list', ['ui.tree']).component('contactList', new ContactListComponent());



// WEBPACK FOOTER //
// ./src/modules/contact/components/contact-list/contact-list-module.js